import Vue from 'vue'
import Router from 'vue-router'
import axiosObject from "../plugins/axios";
import { userStore } from "../store";

import salesRoutes from './salesRoutes';
import operationRoutes from "./operationRoutes";
import accountingRoutes from './accountingRoutes';
import purchaseRoutes from './purchaseRoutes';
import warehouseRoutes from './warehouseRoutes';
import maintenanceRoutes from './maintenanceRoutes';
import ticketRoutes from './ticketRoutes';
import settingRoutes from './settingRoutes';
import hrisRoutes from './hrisRoutes';
import carManagementRoutes from './carManagementRoutes';
// import profileRouter from './profileRouter';
import visitorLogRoutes from './visitorLogRoutes';
import mcuRoutes from './mcuRoutes';
import sheEquipmentRouter from './sheEquipmentRouter';

Vue.use(Router);

// eslint-disable-next-line no-unused-vars
const requireAuth = (to, from, next) => {

    const store = userStore();
    if (!store.token) {
        store.setIncomingUrl(to.fullPath);
        next({ name: 'login' });
    } else {
        axiosObject.defaults.headers.token = store.token;
        axiosObject.post("/auth/token", {
            token: store.token
            // eslint-disable-next-line no-unused-vars
        }).then(response => {
            // console.log(response.status);
            next();
            // eslint-disable-next-line no-unused-vars
        }).catch(error => {
            store.unsetUserState();
            store.tokenUnSet();
            next({ name: 'login' });
        });
    }
}

// eslint-disable-next-line no-unused-vars
const getUser = (to, from, next) => {

    const store = userStore();
    if (store.user) {
        if (store.token) {
            next({ path: '/' });
        } else {
            next();
        }
    } else {
        next({ name: 'login' });
    }
}

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: () => import('../views/admin/layouts/AdminSkeleton'),
            beforeEnter: requireAuth,
            redirect: { name: 'index' },
            children: [
                {
                    path: '/index.html',
                    name: 'index',
                    meta: {
                        title: "Index",
                        show: false
                    },
                    component: () => import('../views/admin/page/HomePage/Index'),
                },
                ...salesRoutes,
                ...operationRoutes,
                ...accountingRoutes,
                ...purchaseRoutes,
                ...warehouseRoutes,
                ...maintenanceRoutes,
                ...ticketRoutes,
                ...settingRoutes,
                ...hrisRoutes,
                ...carManagementRoutes,
                // ...profileRouter,
                ...visitorLogRoutes,
                ...sheEquipmentRouter,
                ...mcuRoutes,
                {
                    path: '/eventlog',
                    name: 'eventlog',
                    meta: {
                        title: "Event Log",
                        show: false
                    },
                    component: () => import('../views/admin/page/EventLog/EventLogDashboard'),
                },
                // Users
                {
                    path: '/register',
                    meta: {
                        title: "Users",
                        icon: "account.png",
                        show: true
                    },
                    component: () => import(/* webpackChunkName: "user" */ '../views/admin/page/Register/Index'),
                    redirect: { name: 'register' },
                    children: [
                        {
                            path: 'register',
                            name: 'register',
                            meta: {
                                title: "Register",
                                show: true
                            },
                            component: () => import(/* webpackChunkName: "user" */ '../views/admin/page/Register/Register'),
                        }
                    ]
                },
                // group
                {
                    path: '/group',
                    meta: {
                        title: "Groups",
                        icon: "group.png",
                        show: true
                    },
                    component: () => import(/* webpackChunkName: "group" */ '../views/admin/page/GroupPage/Index'),
                    redirect: { name: 'group' },
                    children: [
                        {
                            path: 'group',
                            name: 'group',
                            meta: {
                                title: "Group",
                                show: true
                            },
                            component: () => import(/* webpackChunkName: "group" */ '../views/admin/page/GroupPage/Group'),
                        },
                        {
                            path: 'group/:idgroup',
                            name: 'groupdetail',
                            meta: {
                                title: "Group Detail",
                                show: true
                            },
                            props: true,
                            component: () => import(/* webpackChunkName: "group" */ '../views/admin/page/GroupPage/GroupDetail'),
                        },

                        {
                            path: 'group/create',
                            name: 'groupcreate',
                            meta: {
                                title: "Group Detail",
                                show: true
                            },
                            component: () => import(/* webpackChunkName: "group" */ '../views/admin/page/GroupPage/GroupDetail'),
                        }
                    ]
                },
                // menu
                {
                    path: '/menu',
                    meta: {
                        title: "Menu Items",
                        icon: "menu-logo.png",
                        show: true
                    },
                    component: () => import(/* webpackChunkName: "menu" */ '../views/admin/page/MenuPage/Index'),
                    redirect: { name: 'menuitems' },
                    children: [
                        {
                            path: 'items',
                            name: 'menuitems',
                            meta: {
                                title: "Menu Items",
                                show: true
                            },
                            component: () => import(/* webpackChunkName: "menu" */ '../views/admin/page/MenuPage/MenuItems'),
                        }
                    ]
                }
            ]
        },
        {
            path: '/login',
            component: () => import('../views/auth/page/Login'),
            name: 'login'
        },
        {
            path: '/otp',
            component: () => import('../views/auth/page/Otp'),
            beforeEnter: getUser,
            name: 'otp'
        },
        {
            path: '/p2k3',
            component: () => import('../views/client/FormInspection'),
            name: 'p2k3'
        },
        {
            path: '/visitor',
            component: () => import('../views/client/VisitorLog'),
            name: 'visitor'
        },
        {
            path: '/equipment/:model/:id',
            component: () => import('../views/client/SHEEquipmentViewer'),
            name: 'equipment',
            props: true,
        },
        {
            path: '/workpermit',
            component: () => import('../views/client/FormWorkPermit'),
            name: 'workpermit'
        },
        {
            path: '/customer/:id',
            component: () => import('../views/client/CustomerDashboard'),
            name: 'customer',
            props: true,
        },
        {
            path: '/questionnaire/:string?',
            component: () => import('../views/client/CustomerQuestionnaire'),
            name: 'questionnaire',
            props: true,
        },
        {
            path: '/chart',
            component: () => import('../views/client/ChartView'),
            name: 'chart'
        },
        {
            path: '/mcutest',
            component: () => import('../views/client/MonthlyCheckUp'),
            name: 'mcu'
        },
        {
            path: "*",
            component: () => import('../views/client/404Page'),
            name: 'error404'
        }
    ],
    // eslint-disable-next-line no-unused-vars
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
});

export default router
